var $67f4d0b0de9f8a52$exports = {};
$67f4d0b0de9f8a52$exports = {
  "Clear search": "Suche zur\xFCcksetzen"
};
export { $67f4d0b0de9f8a52$exports as default };